import { useEffect } from "react";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { usePreflightDraftStore } from "../stores/preflight-draft.store";

/** Tracks the last tenant seen while Pre Flight routes were mounted. */
let trackedTenantId: string | null | undefined;

/**
 * Clears the client draft when the active tenant changes. Upload ids are
 * tenant-owned — carrying them across a switch makes Analyze fail until the
 * user re-uploads.
 */
export function usePreflightDraftTenantSync() {
  const activeTenantId = useAuth((s) => s.activeTenantId);

  useEffect(() => {
    if (activeTenantId == null) return;

    if (trackedTenantId !== undefined && trackedTenantId !== activeTenantId) {
      usePreflightDraftStore.getState().clear();
    }

    trackedTenantId = activeTenantId;
  }, [activeTenantId]);
}

/** Test-only reset for module-level tenant tracking. */
export function resetPreflightDraftTenantTracking() {
  trackedTenantId = undefined;
}
